/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scene_Description_Import_DescriptionInputs */

const en_scene_description_import_description = /** @type {(inputs: Scene_Description_Import_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import completed shot description jobs into your project.`)
};

const fr_scene_description_import_description = /** @type {(inputs: Scene_Description_Import_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importez les descriptions de plans terminées dans votre projet.`)
};

const de_scene_description_import_description = /** @type {(inputs: Scene_Description_Import_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importieren Sie abgeschlossene Shot-Beschreibungsaufträge in Ihr Projekt.`)
};

const it_scene_description_import_description = /** @type {(inputs: Scene_Description_Import_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importa i lavori di descrizione delle riprese completati nel tuo progetto.`)
};

const ru_scene_description_import_description = /** @type {(inputs: Scene_Description_Import_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Импортируйте завершенные задания по описанию кадров в свой проект.`)
};

const es_scene_description_import_description = /** @type {(inputs: Scene_Description_Import_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importa los trabajos de descripción de tomas completados a tu proyecto.`)
};

const zh_cn2_scene_description_import_description = /** @type {(inputs: Scene_Description_Import_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将已完成的镜头描述任务导入到您的项目中。`)
};

const ja_scene_description_import_description = /** @type {(inputs: Scene_Description_Import_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完了した撮影説明ジョブをプロジェクトにインポートします。`)
};

const hi_scene_description_import_description = /** @type {(inputs: Scene_Description_Import_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पूर्ण हो चुके शॉट विवरण कार्यों को अपने प्रोजेक्ट में आयात करें।`)
};

const pt_pt2_scene_description_import_description = /** @type {(inputs: Scene_Description_Import_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importe as descrições de planos concluídas para o seu projeto.`)
};

/**
* | output |
* | --- |
* | "Import completed shot description jobs into your project." |
*
* @param {Scene_Description_Import_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const scene_description_import_description = /** @type {((inputs?: Scene_Description_Import_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Description_Import_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_scene_description_import_description(inputs)
	if (locale === "de") return de_scene_description_import_description(inputs)
	if (locale === "it") return it_scene_description_import_description(inputs)
	if (locale === "ru") return ru_scene_description_import_description(inputs)
	if (locale === "es") return es_scene_description_import_description(inputs)
	if (locale === "zh-CN") return zh_cn2_scene_description_import_description(inputs)
	if (locale === "ja") return ja_scene_description_import_description(inputs)
	if (locale === "hi") return hi_scene_description_import_description(inputs)
	if (locale === "pt-PT") return pt_pt2_scene_description_import_description(inputs)
	return en_scene_description_import_description(inputs)
});